<template>
  <ModuleBase
    :navItems="navItems"
    noPadding
    fullHeight
    gray
  />
</template>

<script
  setup
  lang="ts"
>
import dayjs from 'dayjs';
import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import ModuleBase from '@/modules/ModuleBase.vue';
import { useCompanyStore } from '@/stores/company';
import { useGoogleReserveStore } from '@/stores/google-reserve';
import { useTreatwellStore } from '@/stores/treatwell';
import { useUserStore } from '@/stores/user';
import unleash from '@/unleash';

const { company, updateCompany } = useCompanyStore();
const { hasDashboard, showTreatwell, showTWOnboardingNotification } =
  useTreatwellStore();
const { showIntegration: showGoogleReserve } = storeToRefs(
  useGoogleReserveStore(),
);
const { t } = useI18n();
const { hasFeatureFlag } = useUserStore();

const navItems = computed(() => {
  const appointmentsItem = hasFeatureFlag('module-appointments')
    ? [
        {
          text: t('global.pages.booking_widget'),
          name: 'online-booking-widget',
        },
      ]
    : [];

  const marketplaceItem = showTreatwell
    ? [
        {
          text: t('global.pages.marketplace'),
          name: hasDashboard ? 'treatwell-admin' : 'treatwell-landing',
          notification: {
            show: showTWOnboardingNotification,
            value: '!',
          },
        },
      ]
    : [];

  const otherItems = [
    ...(unleash.isEnabled('WebsiteService')
      ? [
          {
            text: t('global.pages.website_service'),
            name: 'online-website-service',
          },
        ]
      : []),
    ...(showGoogleReserve.value
      ? [
          {
            text: t('global.pages.google_reserve'),
            name: 'online-google-reserve',
          },
        ]
      : []),
  ];

  return hasFeatureFlag('treatwell-brand')
    ? [...marketplaceItem, ...appointmentsItem, ...otherItems]
    : [...appointmentsItem, ...marketplaceItem, ...otherItems];
});

onMounted(() => {
  if (!company.settings.onlineRoutes.lastVisitedAt) {
    updateCompany({
      settings: {
        onlineRoutes: {
          lastVisitedAt: dayjs().format(),
        },
      },
    });
  }
});
</script>
